import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'

import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
import axios from 'axios'
import { connectNode } from '../../utils/global'
import { loadLocationWithMessage } from '../../actions/location'
import NavBarAbout from "../../components/structure/NavBarAbout"
import Background from '../../images/title-about.jpg'
import Announcement from "../structure/announcement"
import OurTeam from "./ourteam"

class About extends Component {
  constructor() {
      super()
      this.state = {
          status: false,
          content: '',
          name: '',
          date_time: '',
          title: '',
          banner_title: '',
          body: '',
      }
  }

  componentDidMount() {
    this.getContent()
  }

  getContent = () => {
    var nid = 0
    var title = ''
    var banner_title = ''
    var get_uri2 = this.props.match.params.page
    var body = null

    if(get_uri2 == 'our-team') {
      nid = 2
      title = 'Who We Are'
      banner_title = 'Our Team'
      body = <OurTeam />
    } else if(get_uri2 == 'dauten-family') {
      nid = 9
      title = 'About the Dauten Family'
      banner_title = title
      body = '<div><div><h2><img src="../img/Dautens.jpg" class="img-fluid" alt=""></h2></div>'
            +'<p>Kent and Liz Dauten have a deeply-rooted history of philanthropy in the health sciences, specifically expanding the understanding and treatment of bipolar disorder. In 2017, they established the Dauten Family Center for Bipolar Treatment Innovation (DCBI) at Massachusetts General Hospital with the mission to provide top-quality care to people living with bipolar disorder. The DCBI provides:</p>'
            +'<p><ul><li>Quality clinical care</li><li>Cutting edge research</li><li>Increasing understanding of bipolar disorder</li></ul></p><p>Since its inception, the DCBI has grown into a team of over 30 staff members, including psychologists, psychiatrists, clinical research coordinators, and administrative staff---all dedicated to improving outcomes for people living with bipolar disorder. Our innovative research projects range from the testing of Xenon– a chemical element that has the potential to be a novel antidepressant drug–to evaluating the effectiveness of yoga as a treatment for both unipolar and bipolar depression. We also established the FITT-BD clinic, a goal-oriented outpatient program designed to empower people with bipolar disorder to learn the skills needed to independently manage their condition.</p>'
            +'<p>None of this would be possible without the support of the Dauten family. Their philanthropic contributions enable us to pursue cutting-edge research ideas and provide state-of-the-art clinical care that has the potential to transform lives of patients, families, clinicians, and the broader field of mental health care. We are profoundly grateful for their commitment and belief in our mission.</p>'
            +'<h3>Our Work in Action</h3>'
            +'<p><ul><li><a href="/files/DautenCenterAnnualReport2025.pdf" target="_blank">2025 Annual Report</a></li>'
            +'<li><a href="/files/DautenCenterAnnualReport2024.pdf" target="_blank">2024 Annual Report</a></li>'
            +'<li><a href="/files/DautenCenterAnnualReport2023.pdf" target="_blank">2023 Annual Report</a></li>'
            +'<li><a href="/files/DautenCenterAnnualReport2022.pdf" target="_blank">2022 Annual Report</a></li>'
            +'<li><a href="/files/DautenCenterAnnualReport2021.pdf" target="_blank">2021 Annual Report</a></li>'
            +'<li><a href="/files/DautenCenterAnnualReport2020.pdf" target="_blank">2020 Annual Report</a></li>'
            +'<li><a href="/files/DautenCenterAnnualReport2019.pdf" target="_blank">2019 Annual Report</a></li></ul></p></div>'
    } else if(get_uri2 == 'scientific-advisory-board') {
      nid = 8
      title = 'Scientific Advisory Board'
      banner_title = title
    }

    if(get_uri2 != 'our-team' && get_uri2 != 'dauten-family') {
      axios({
        method: 'post',
        url: connectNode + 'admin/content/get_content_1',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: { nid: nid }
      })
      .then((result) => {
        this.setState({
          title: title,
          banner_title: banner_title,
          body: result['data'].body_value,
        })
      })
    } else {
      this.setState({
        title: title,
        body: body,
        banner_title: banner_title,
      })
    }
  }

  render() {
    var sectionStyle = {
      backgroundColor: 'rgba(0,52,86,1.00)',
      padding: '3% 0% 3% 0%',
      color: 'rgba(255,255,255,1.0)',
      backgroundImage: `url(${Background})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
    };
    return (
    <div>
      <div className="container-fluid sectionTitle" style={ sectionStyle }>
        <div className="row">
          <div className="col-md-10 offset-md-1 col-sm-12 offset-sm-0">
            <h1>{this.state.banner_title}</h1>
          </div>
        </div>
      </div>
      <div className="container-fluid sectionBody">
        <div className="row">
          <div className="col-lg-3 offset-lg-1 col-md-10 offset-md-1 order-lg-1 order-2 sideBar">
            <NavBarAbout loggedIn={this.state.loggedIn} />
            <Announcement />
          </div>
          <div className="col-lg-7 offset-lg-0 col-md-10 offset-md-1 col-sm-12 offset-sm-0 order-lg-2 order-1 px-3 pageBody">
            <div>
              <h2>{this.state.title}</h2>
              {typeof this.state.body === 'string'
              ? ReactHtmlParser(this.state.body)
              : this.state.body}
            </div>
          </div>
        </div>
      </div>

    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(About)

/**/
